module.exports = __webpack_public_path__ + "img/calendar_filter.73870362.svg";